import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Meh } from 'react-feather';
import classnames from 'classnames';

const Empty = ({
  icon,
  className,
  titleClassName,
  subTitleClassName,
  titleId,
  title,
  subTitleId,
  subTitle,
}) => {
  return (
    <div
      className={classnames(
        'd-flex justify-content-center align-items-center flex-column',
        className,
      )}
    >
      {icon || <Meh size={60} className="primary mb-1" />}
      <span
        className={classnames(
          'text-center mx-2 font-medium-3 black mb-25',
          titleClassName,
        )}
      >
        {title || <FormattedMessage id={titleId} />}
      </span>
      {(title || subTitleId) && (
        <span
          className={classnames(
            'text-center mx-2 font-small-3',
            subTitleClassName,
          )}
        >
          {subTitle || <FormattedMessage id={subTitleId} />}
        </span>
      )}
    </div>
  );
};

export default Empty;
